export default __webpack_public_path__ + "static/media/forget-password.81c0955a.png";